export const paths = ['/company-settings'];
